import { ErrorEvent } from '@sentry/types/types/event';
import { gameDataService } from 'services';


const errors = [
    'user.already.has.this.activity',
];


export const beforeSend = async (event: ErrorEvent) => {
    const isErrorExcluded = errors.some(error => event.message && event.message.includes(error));

    if (isErrorExcluded) return null;

    const userId = await gameDataService.userId;
    const gameId = await gameDataService.gameId;

    if (userId) {
        event.user = {
            ...event.user,
            id: userId,
            gameId,
        };
    }

    return event;
};
